import {
  GeckoAssetModel,
  GeckoComponentDataFrame,
  GeckoComponentModel,
  GeckoInspection,
  GeckoPotreePointCloud,
} from 'types'

import { AllSceneFactoryProps, SceneFactoryConfig } from './sceneFactory'

interface SceneDispatchProps {
  showMultiComponentView: boolean
  showAxesHelper: boolean
  assetModel: GeckoAssetModel | undefined
  componentModel: GeckoComponentModel | undefined
  inspection: GeckoInspection | undefined
  cdf: GeckoComponentDataFrame | undefined
  pointCloud: GeckoPotreePointCloud | undefined
}

export const sceneDispatch = (
  sceneFactoryConfigs: SceneFactoryConfig[],
  {
    showMultiComponentView,
    showAxesHelper,
    assetModel,
    componentModel,
    inspection,
    cdf,
    pointCloud,
  }: SceneDispatchProps
) => {
  const sceneFactoryProps: AllSceneFactoryProps = {
    assetModel,
    componentModel,
    inspection,
    cdf,
    showAxesHelper,
    pointCloud,
  }

  for (const config of sceneFactoryConfigs) {
    if (
      showMultiComponentView !== !!config.multiComponentView ||
      (config.assetModels &&
        (!assetModel || !config.assetModels.includes(assetModel.data.type))) ||
      (config.componentModels &&
        (!componentModel ||
          !config.componentModels.includes(componentModel.type))) ||
      (config.otherChecks && !config.otherChecks(sceneFactoryProps))
    )
      continue

    if (config.sceneFunc && !!assetModel && !!componentModel) {
      return config.sceneFunc({
        assetModel: assetModel,
        componentModel: componentModel,
      })
    }

    if (config.fullSceneFunc) return config.fullSceneFunc(sceneFactoryProps)
  }
  return null
}
